var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"EvoucherName"}},[_c('div',{staticClass:"description"},[_vm._v(" "+_vm._s(_vm.voucherDetail.productName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }